import { newCardsCss } from 'src/content/dashboard/DashboardCss';
import { pdfContainerSx } from './PdfSxs';

export const PdfGscCard = () => {
  return (
    <>
      <div
        style={{
          ...pdfContainerSx?.pdfCardsSx,
          ...pdfContainerSx?.gscCardBoxSx
        }}
      >
        <p style={{ ...pdfContainerSx?.gscTitleTextSx, textAlign: 'center' }}>
          {'Connect SEOSpace to Google Search Console '}
        </p>
        <p style={{ ...pdfContainerSx?.gscDescTextSx, textAlign: 'center' }}>
          {
            'Connect SEOSpace to Google Search Console to access personalized recommendations and advanced insight to improve your SEO.'
          }
        </p>
        <img
          draggable={false}
          src={process.env.PUBLIC_URL + `/static/images/icons/pluginImg.png`}
          style={{
            ...newCardsCss?.gscImgStyle,
            ...newCardsCss?.gscImgBoxSx
          }} // Ensure the image doesn't overflow
        />
      </div>
    </>
  );
};
